import { SanitizeLevel } from '@openreplay/tracker'

const SENSITIVE_FIELD_NAME_PATTERN = /ssn|socialsecurity|taxid|dob|dateofbirth|birth|routing|accountnumber|income|password/i
const EMPLOYER_IDENTIFICATION_NUMBER_FIELD_NAME = 'ein'

const isSensitiveFieldName = (fieldName: string | null): boolean => {
    if (fieldName === null) {
        return false
    }
    const normalizedFieldName = fieldName.replace(/[^a-z0-9]/gi, '')
    return SENSITIVE_FIELD_NAME_PATTERN.test(normalizedFieldName) || normalizedFieldName.toLowerCase() === EMPLOYER_IDENTIFICATION_NUMBER_FIELD_NAME
}

const isBirthdayAutocomplete = (autocomplete: string | null): boolean => autocomplete !== null && autocomplete.trim().toLowerCase().startsWith('bday')

export const resolveOpenReplaySanitizeLevelForElement = (element: Element): SanitizeLevel => {
    if (element.hasAttribute('data-pii') || isSensitiveFieldName(element.getAttribute('name')) || isBirthdayAutocomplete(element.getAttribute('autocomplete'))) {
        return SanitizeLevel.Obscured
    }
    return SanitizeLevel.Plain
}
